export const GL_USER_CONFIG_UPDATED = "GL_USER_CONFIG_UPDATED";
export const GL_NEXT_DATA_TO_STATE  = "GL_NEXT_DATA_TO_STATE";
export const PAGE_RECEIVED_DATA     = 'PAGE_RECEIVED_DATA';
export const GLOBAL_ACCOUNT_CONFIG  = `//media.zones.com/zones-connect/zones-connect-account-settings.json`;